import { Button, Group, Modal, Stack, Text } from "@mantine/core";
import type { SourceDefaultStain } from "../../../services/admin/sourcedefaultstains.service";

interface Props {
  opened: boolean;
  item: SourceDefaultStain | null;
  isDeleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function SourceDefaultStainDeleteModal({
  opened,
  item,
  isDeleting,
  onClose,
  onConfirm,
}: Props) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Delete source default stain"
      size="sm"
      centered
      closeOnClickOutside={false}
    >
      <Stack gap="md">
        <Text>
          Remove <strong>{item?.stain?.code}</strong> from{" "}
          <strong>{item?.source?.name}</strong>?
        </Text>
        <Text size="sm" c="dimmed">
          This source will no longer add the stain automatically.
        </Text>
        <Group justify="space-between" mt="md">
          <Button variant="default" onClick={onClose}>
            Cancel
          </Button>
          <Button color="red" onClick={onConfirm} loading={isDeleting}>
            Delete source default stain
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
